var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_234",
    "data-name": "Rect\\xE1ngulo 234",
    width: 22,
    height: 24,
    transform: "translate(61 367)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_2",
    "data-name": "Enmascarar grupo 2",
    transform: "translate(-61 -367)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_525",
    "data-name": "Grupo 525",
    transform: "translate(3 -70)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1",
    "data-name": "Rect\\xE1ngulo 1",
    width: 27.603,
    height: 27.603,
    rx: 1,
    transform: "translate(52.198 435.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_684",
    "data-name": "Trazado 684",
    d: "M25.844,18.505l0,0,0,0Zm0,0L28,20.792V16.234Zm-14.662-3.9V22.44H17.86v-1.8H13.325V19.406h4.42V17.637h-4.42V16.418H17.86V14.606Zm14.043,0-2.293,2.506-2.274-2.506h-2.8l3.692,3.931L17.86,22.469h2.729l2.293-2.529,2.293,2.529.013-.039H28L24.285,18.5,28,14.606Zm-9.777-1.137h0ZM12.988,7.592l1.065,2.565H11.926Zm-1.343-1.96L8.191,13.469h2.352L11.2,11.9h3.6l.655,1.569h2.4l-3.44-7.837Zm13.079,0-1.756,4.882L21.221,5.632H17.856v7.837h2.13V7.981L22,13.469h1.881l2-5.5v5.5H28V5.632ZM0,0V28H28V23.564H24.622l-1.74-1.924-1.746,1.924H10V14.6h-3.6L10.851,4.508H15.16l1.55,3.46V4.508h5.311l.924,2.621.927-2.621H28V0Z",
    transform: "translate(52 435)",
    fill: "#006fcf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.0a1d513af1301250ccf0e33d5c9520d1.svg";
export { ForwardRef as ReactComponent };